{
  "commonHeader": {
    "toggleSidebar": "Seitenleiste umschalten",
    "cartLoading": "Warenkorb wird geladen",
    "cart": "Warenkorb",
    "aicForAdmin": {
      "ariaLabel": "KI für Admins"
    },
    "usersResults": "Benutzer, {0} Ergebnisse",
    "settingsResults": "Einstellungen, {0} Ergebnisse",
    "navigationResults": "Navigation, {0} Ergebnisse",
    "learnMoreAbout": "Mehr über {0} erfahren",
    "close": "Schließen",
    "products": "Produkte",
    "moreActions": "Weitere Aktionen",
    "search": "Suchen",
    "searchPlaceholderAll": "Nach Benutzern, Kontoeinstellungen oder Navigation suchen",
    "searchPlaceholderUsers": "Nach Benutzern oder Navigation suchen",
    "searchPlaceholderSettings": "Nach Kontoeinstellungen oder Navigation suchen",
    "searchPlaceholderNav": "Nach Navigation suchen"
  },
  "footerCopyright": {
    "language": "Sprache {0}"
  },
  "adminMenu": {
    "adminMenu": {
      "ariaLabel": "Admin-Menü"
    }
  },
  "shared": {
    "close": "Schließen",
    "sideMenu": {
      "personalAria": "Persönliches Menü",
      "adminAria": "Admin-Menü",
      "mainNav": "Hauptnavigation",
      "submenu": "Untermenü",
      "pinnedSection": "{0} angeheftet",
      "sideMenuAria": "Seitenmenü",
      "pinItem": "{0} anheften",
      "unpinItem": "{0} losheften",
      "reorderGrabbed": "{0} neu anordnen, gegriffen. Mit den Pfeiltasten nach oben und unten verschieben, Leertaste oder Eingabe zum Ablegen, Escape zum Abbrechen.",
      "reorderIdle": "{0} neu anordnen. Leertaste oder Eingabe zum Greifen.",
      "hintHandlePin": "Drücken Sie Tab, um den Ziehgriff und die Anheftschaltfläche zu erreichen",
      "hintHandle": "Drücken Sie Tab, um den Ziehgriff zu erreichen",
      "hintPin": "Drücken Sie Tab, um die Anheftschaltfläche zu erreichen",
      "upgradeToPro": "Auf Pro upgraden"
    },
    "item": "Element"
  },
  "coachMark": {
    "coachMark": {
      "tryNewExperienceAria": "Neue Oberfläche ausprobieren"
    }
  },
  "aicGuide": {
    "common": {
      "close": "Schließen"
    }
  },
  "divisionTips": {
    "coachMark": {
      "dvsTipsTitle": "Divisionen sind jetzt verfügbar"
    }
  },
  "externalAccountTips": {
    "coachMark": {
      "extAccountTipsTitle": "Externe Konten verwalten"
    }
  },
  "zccRenameTips": {
    "coachMark": {
      "tipsTitle": "Adressbuch wird zu Kundenverzeichnis"
    }
  },
  "feedback": {
    "itemLableForProductArea": "Produktbereich",
    "itemLableForFeedback": "Feedback"
  }
}
